module.exports = __webpack_public_path__ + "media/images/about-us-product-bg-32b28a30abfa1c24b86560d2c3b66808.jpg";